/* eslint-disable default-param-last */
import * as actionType from '../constants/users';
import * as authType from '../constants/auth';

const getInitialOverview = () => {
  try {
    const activeApp = localStorage.getItem('activeApp');
    if (activeApp) {
      const app = JSON.parse(activeApp);
      const appId = app?._id;
      if (appId) {
        const cached = localStorage.getItem(`cached_dashboard_overview_${appId}`);
        if (cached) return JSON.parse(cached);
      }
    }
    const cached = localStorage.getItem('cached_dashboard_overview');
    return cached ? JSON.parse(cached) : null;
  } catch (e) {
    return null;
  }
};

const initialState = {
  users: [],
  staffMembers: [],
  usersWallet: [],
  walletSum: 0,
  commissionSum: 0,
  overview: getInitialOverview(),
  isLoading: false,
  added: false,
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case authType.CLEAR_APP_DATA:
    case authType.USER_LOGOUT:
      try {
        localStorage.removeItem('cached_dashboard_overview');
        Object.keys(localStorage).forEach((key) => {
          if (key.startsWith('cached_dashboard_overview_')) {
            localStorage.removeItem(key);
          }
        });
      } catch (e) {
        // Ignore storage error
      }
      return {
        ...initialState,
        overview: null,
      };
    case actionType.USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionType.USER_LOADED:
      return {
        ...state,
        isLoading: false,
      };
    case actionType.GET_STAFF_MEMBERS:
      return {
        ...state,
        staffMembers: action.payload,
        isLoading: false,
      };
    case actionType.CREATE_STAFF_MEMBER:
      return {
        ...state,
        users: [action.payload, ...state.staffMembers],
        isLoading: false,
        added: true,
      };
    case actionType.GET_USERS:
      return {
        ...state,
        users: Array.isArray(action.payload) ? action.payload : action.payload?.users || [],
        usersTotalCount: action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0),
        usersCurrentPage: action.payload?.currentPage || 1,
        usersTotalPages: action.payload?.totalPages || 1,
        isLoading: false,
      };
    case actionType.CREATE_USER:
      return {
        ...state,
        users: [action.payload.user, ...state.users],
        isLoading: false,
        added: true,
      };
    case actionType.REMOVE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
        isLoading: false,
      };
    case actionType.UPDATE_USER:
      return {
        ...state,
        isLoading: false,
        added: true,
      };
    case actionType.GET_USERS_WALLET: {
      let wallets = [];
      const payloadWallets = action.payload?.wallets;
      if (Array.isArray(payloadWallets)) {
        wallets = payloadWallets;
      } else if (Array.isArray(action.payload)) {
        wallets = action.payload;
      }
      return {
        ...state,
        usersWallet: wallets,
        walletSum: action.payload?.walletSum || 0,
        commissionSum: action.payload?.commissionSum || 0,
        walletsTotalCount: action.payload?.totalCount || 0,
        walletsCurrentPage: action.payload?.currentPage || 1,
        walletsTotalPages: action.payload?.totalPages || 1,
        isLoading: false,
      };
    }
    case actionType.GET_DASHBOARD_OVERVIEW: {
      try {
        const activeApp = localStorage.getItem('activeApp');
        if (activeApp) {
          const app = JSON.parse(activeApp);
          const appId = app?._id;
          if (appId) {
            localStorage.setItem(`cached_dashboard_overview_${appId}`, JSON.stringify(action.payload));
          }
        }
        localStorage.setItem('cached_dashboard_overview', JSON.stringify(action.payload));
      } catch (e) {
        // Ignore storage errors
      }
      return {
        ...state,
        overview: action.payload,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}


